import {LIVE_INIT, LIVE_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as TimeTableActions from 'actions/Timetable';
import * as MatchResultActions from 'actions/MatchResults';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as ChangeLanguageActions from 'actions/changeLanguage';

import * as RepositoryState from 'constants/RepositoryState';

export default function stateReducer(state, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
        case TimeTableActions.CLEAR_TIME_TABLE:
        case ChangeLanguageActions.CHANGE_LANGUAGE:
        case LIVE_INIT.FAILURE:
        case LIVE_UPDATE.FAILURE:
        case TIMETABLE_INIT.FAILURE:
        case TIMETABLE_UPDATE.FAILURE:
            return RepositoryState.NOT_INITED;

        case LIVE_INIT.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
            return RepositoryState.INITED;

        case LIVE_UPDATE.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            if (action.data.expired && action.data.expired === true) {
                return RepositoryState.NOT_INITED;
            }

            return RepositoryState.UPDATING;
    }

    return state;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/stateReducer.js